import React from 'react';
import { AppUI } from '@seedlang/state';

export const ComponentForSeedlangOrMemrevSite = (ComponentForSeedlangSite, ComponentForMemrevSite) => (
  props => (
    AppUI.siteIsSeedlang ? <ComponentForSeedlangSite {...props} /> : <ComponentForMemrevSite {...props} />
  )
);
